import React, { useRef, useEffect } from 'react';
import clsx from 'clsx';
import {
  HorizontalScrollContainer,
  Typography,
  FontType
} from '@americanexpress/aqx-components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

import styles from '../__styles__/index.scss?modules';

const MobileVariantA = ({ data, shortName }) => {
  const currentRef = useRef(null);

  const parsedDtmEvents = parseArrayToObject(data?.dtmEvents || [], 'key');

  useEffect(() => {
    if (currentRef.current) {
      currentRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, []);

  const dtmClickEvent = dtmName => {
    const dtm = {
      ...(parsedDtmEvents?.carouselTileClick || {}),
      eventAsset: replaceStringWithVars({
        varsObject: {
          cardName: dtmName
        },
        string: parsedDtmEvents?.carouselTileClick?.eventAsset || ''
      })
    };
    sendDTMClickEvent(dtm);
  };

  return (
    <div className={styles.mobileVariantA}>
      <HorizontalScrollContainer
        rightButtonProps={{
          onClick: () => {
            sendDTMClickEvent(parsedDtmEvents?.carouselRightScrollClick);
          }
        }}
        leftButtonProps={{
          onClick: () => {
            sendDTMClickEvent(parsedDtmEvents?.carouselLeftScrollClick);
          }
        }}
      >
        <section className={styles.buttonCarousel}>
          {data?.content?.map(eachCard => (
            <a
              key={eachCard?.shortName}
              className={clsx(styles.mobileVariantAButton, {
                [styles.currentCard]: shortName === eachCard?.shortName
              })}
              href={eachCard?.url}
              ref={shortName === eachCard?.shortName ? currentRef : null}
              onClick={() => dtmClickEvent(eachCard?.dtmName)}
            >
              <img src={eachCard?.imageName} alt="" />
              <Typography
                $family={FontType.HelveticaRegular}
                $size="11px"
                $lineHeight="16px"
              >
                {eachCard?.name}
              </Typography>
            </a>
          ))}
        </section>
      </HorizontalScrollContainer>
    </div>
  );
};

export default MobileVariantA;
